import React from 'react';
import QRCode from 'react-qr-code';
import PropTypes from 'prop-types';

export const QRCodeField = ({ value }) => (
  <div className="qr-code-field">
    <QRCode size={130} value={value} />
  </div>
);

QRCodeField.propTypes = {
  value: PropTypes.string.isRequired,
};
